import { Component, OnInit } from '@angular/core';
import { PaymentService, ProductDisplay, Subscription } from '../payment.service';
import { UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'cart-view',
  templateUrl: './cart-view.component.html',
  styleUrls: ['./cart-view.component.css']
})
export class CartViewComponent implements OnInit{
  subs: Subscription[];
  selectedSub: Subscription;
  products: ProductDisplay[];
  selectedProduct: ProductDisplay;

  constructor(private paymentService: PaymentService, private utilService: UtilitieService){

  }

  async goToCheckout(){
    const session = await this.paymentService.getCheckoutSession(this.selectedProduct);
    if(session){
      const { error } = await this.paymentService.checkout(session.id);
    }
  }

  selectProduct(product: ProductDisplay){
    this.selectedProduct = product;
  }

  async ngOnInit(): Promise<void> {
    this.utilService.updateLoading(true);
    this.subs = [];
    this.products = [];
    this.selectedSub = this.subs[0];
    this.products = await this.paymentService.getProducts();
    this.selectedProduct = this.products[0];
    this.utilService.updateLoading(false);
  }

}
